export const baseURL = "/partner-broker-onboarding";
export const planUploadURL = `${baseURL}/plan-upload`;
export const doneURL = `${baseURL}/done`;
